import React from 'react';
import { Box } from '@mui/material';
import { InvestmentType } from '@inversor-hub/types';
import { investmentTypeLabels } from '@/features/investments/constants.ts';

interface InvestmentTypeBadgeProps {
  type: InvestmentType;
}

export const InvestmentTypeBadge: React.FC<InvestmentTypeBadgeProps> = ({ type }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        zIndex: 2,
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: '0.75rem',
        fontWeight: 600,
        color: 'info.contrastText',
        bgcolor: 'info.main',
        boxShadow: 1,
        pointerEvents: 'none',
      }}
    >
      {investmentTypeLabels[type]}
    </Box>
  );
};
